import type { ReactNode } from "react";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

interface FooterProps {
  children?: ReactNode;
  sticky?: boolean;
}

export const Footer = ({ sticky, children }: FooterProps) => (
  <div
    className={legacyClassNames("drawer__footer", {
      "drawer__footer--sticky": sticky,
    })}
  >
    {children}
  </div>
);
